module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-smile-fill-3e5cec3c.svg";